import { emptyGuid } from "../utils/emptyGuid"
import { observable, makeObservable, action } from "mobx"
import apiClient from "../utils/api/apiClient"
import { APIEndpoints } from "../utils/api/apiConfig"
import axios from "axios"
const CancelToken = axios.CancelToken
let cancel

class AssetGroupStore {
    constructor(appStore) {
        makeObservable(this, {
            loadedGroupIds: observable,
            loadedGroups: observable,
            groupsLoading: observable,
            allLoaded: observable,
            allGroupsLoading: observable,
            error: observable,
            setError: action,
            clearError: action,
            resetGroups: action,
            setGroupsLoading:action,
            setAllGroupsLoading:action,
            setLoadedGroups:action,
        })

        this.app = appStore
    }
    loadedGroupIds = []
    loadedGroups = []
    groupsLoading = false
    allLoaded = false
    allGroupsLoading = false
    error = ""
    setGroupsLoading(bool) {
        this.groupsLoading = bool
    }
    setAllGroupsLoading(bool) {
        this.allGroupsLoading = bool
    }
    setLoadedGroups(groups) {
        this.loadedGroups = groups
    }
    setError(message) {
        this.error = message
    }

    clearError() {
        this.error = ""
    }

    resetGroups() {
        this.loadedGroupIds = []
        this.loadedGroups = []
        this.allLoaded = false
    }

    async getGroups(groupParentId = emptyGuid) {
        this.loadAllGroups() //loadAll in background
        if (this.loadedGroupIds.includes(groupParentId)) {
            return this.loadedGroups
        } else if (this.groupsLoading) {
            await this.app.uiStore.waitUntilLoaded(
                100,
                "app.assetGroupStore.groupsLoading"
            )
            return this.getGroups(groupParentId)
        } else {
            this.setGroupsLoading(true)
            let _newLoadedGroups = await this.loadTree(groupParentId)
            if (!this.allLoaded) {
                this.setLoadedGroups([...this.loadedGroups, ..._newLoadedGroups])
            }
            this.setGroupsLoading(false)
            return this.loadedGroups
        }
    }

    async loadTree(groupParentId = emptyGuid) {
        this.loadedGroupIds.push(groupParentId)
        const params = {
            "filters.parentGroupId": groupParentId,
        }
        return await apiClient.getJson(APIEndpoints.assetGroups, params)
    }

    async loadAllGroups() {
        if (this.allLoaded) {
            return this.loadedGroups
        } else if (this.allGroupsLoading) {
            await this.app.uiStore.waitUntilLoaded(
                100,
                "app.assetGroupStore.allGroupsLoading"
            )
            return this.loadAllGroups()
        } else {
            this.setAllGroupsLoading(true)
            let allGroups = await apiClient.getJson(APIEndpoints.assetGroups)
            this.resetGroups()
            this.loadedGroupIds.push(emptyGuid)
            allGroups.forEach((group) => {
                this.loadedGroupIds.push(group.id)
            })
            this.setLoadedGroups(allGroups)
            this.allLoaded = true
            this.setAllGroupsLoading(false)
        }
    }

    async getGroup(groupId) {
        return await apiClient.getJson(APIEndpoints.assetgroup(groupId))
    }

    cancelGetFilteredGroups() {
        //cancel previous calls that are still pending
        cancel && cancel()
    }

    async getFilteredGroups(groupName) {
        this.cancelGetFilteredGroups()
        const cancelToken = new CancelToken(function executor(c) {
            cancel = c
        })
        const params = {
            "filters.groupName": groupName,
        }
        return await apiClient.getJson(
            APIEndpoints.assetGroups,
            params,
            true,
            false,
            true,
            { cancelToken }
        )
    }
}
export default AssetGroupStore